import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledSectionHeader = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});
